import { ObjectDb } from './object.db';
import { Injectable } from '@angular/core';
import {
    ServiceSpecialistRecordWorkTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-specialist-record-work-type.object';

@Injectable({ providedIn: 'root' })
export class ServiceSpecialistRecordWorkTypeDb extends ObjectDb<ServiceSpecialistRecordWorkTypeObject> {

    public tableName = 'serviceSpecialistRecordWorkType';

    protected override columnMap = {
        serviceId: 'serviceId',
        name: 'name',
        active: 'active',
    };
    protected override indices = ['id'];
    protected override checkField = 'createdAt';

    protected gqlMethod = 'getServiceSpecialistRecordWorkTypes';

    protected syncFragment = `
        id
        name
        description
        active
        serviceId
        createdAt
    `;

}
